import { get, post, del } from './client';

export const getChannels = () => get('/api/channels');

export const createChannel = (name) => post('/api/channels', { name });

export const deleteChannel = (channelId) => del(`/api/channels/${channelId}`);

export const getMessages = (channelId, limit) =>
  get('/api/messages', limit ? { channel_id: channelId, limit } : { channel_id: channelId });

export const getSecretMessages = (channelId, limit) =>
  get(`/api/channels/${channelId}/secret-messages`, limit ? { limit } : {});

export const getAgents = (channelId) => get(`/api/channels/${channelId}/agents`);

export const addAgent = (channelId) => post(`/api/channels/${channelId}/agents`);

export const removeAgent = (channelId, agentId) => del(`/api/channels/${channelId}/agents/${agentId}`);

export const getCurrentGame = (channelId) => get(`/api/channels/${channelId}/games/current`);

export const startGame = (channelId) => post(`/api/channels/${channelId}/games`);
